module.exports = __webpack_public_path__ + "static/media/exercises-step6.787d6106.png";